













































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {parseXmlToSvg} from '@u/svgUtils';
import draggable from 'vuedraggable';
import Loading from '@c/controls/Loading.vue';
import hardwareModule from '@/store/modules/entities/hardwareModule';
import {HardwareData, HardwareModuleSchema} from '@/system/hardware/interfaces';
import PModuleLink from './pModuleLink.vue';
import PortInput from './PortInput.vue';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {httpClient} from '@/api/baseApi';
import ReloadDialog from './ReloadDialog.vue';

@Component({
  components: {
    PortInput,
    PModuleLink,
    draggable,
    Loading,
    ReloadDialog,
  },
})
export default class Hardware extends Vue {
  @Prop({required: true})
  selectedHardwareId!: number;

  pmodules: any[] = [];

  typeId: number | null = null;

  hardware: HardwareData | null = null;

  loading = false;
  error = false;

  // Показатель режима просмотра
  @Prop({required: false, type: Boolean, default: false})
  showMode!: boolean;

  // Размеры viewBox для svg
  viewBoxSize = {width: 1200, height: 600};

  // Размеры portInput и portLink
  portInputSize = {width: 250, height: 24};

  editFlag = false;

  // добавляемый на SVG узел
  addedItem: any | null = null;

  // смещение координат SVG относительно координат клиентской области приложения
  offsetX!: number;
  offsetY!: number;

  // Ключ для перерисовки элементов дерева
  // Необходимо для обновления css классов элементов дерева при установке locked
  key = 0;

  // при перетаскивании скрываем тултип
  showTooltip = true;

  errorString = '';

  hardwareModuleScheme: HardwareModuleSchema[] | null = [];
  loadingSvg = false;

  portData: any[] = [];

  data: HardwareModuleSchema[] | null = [];

  get reloadDialog() {
    return this.$refs.reloadDialog as any;
  }

  get moduleSchema() {
    if (this.typeId) return this.hardwareModuleScheme?.filter(v => v.id === this.typeId)[0];
    return null;
  }

  get xsOnly() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  get pModules() {
    return pmoduleModule.all;
  }

  async getPortData() {
    this.moduleSchema;
    if (this.moduleSchema) {
      const data = await hardwareModule.getModuleSchemeById(this.moduleSchema.id);
      if (data)
        this.portData = JSON.parse(data.settings).ports ? JSON.parse(data.settings).ports : [];
      else this.portData = [];
    } else {
      this.portData = [];
    }
  }

  async created() {
    await this.setValues();
    await this.getPortData();
    this.$forceUpdate();
  }

  async setValues() {
    const {data} = await hardwareModule.getById(this.selectedHardwareId);
    this.pmodules = data.pmodules;
    this.typeId = data.type_id;
    this.hardware = data;
  }

  async onRemoveModule() {
    await this.redrawSchema();
    this.$emit('updateHardware');
  }

  editHardware(id: any) {
    this.$emit('editHardware', id);
  }

  deleteHardware(id: any) {
    this.$emit('deleteHardware', id);
  }

  onReloadHardwareClick(hardware: any) {
    this.reloadDialog.open(hardware.mac);
  }

  async reloadHardware(hardwareMac: any) {
    await httpClient.put(`modules/actions/device_reboot/`, null, {
      params: {
        mac: hardwareMac,
      },
    });
  }

  getPortModules(portId: number) {
    return this.pmodules.length > 0 ? this.pmodules.filter(m => m.port === portId) : [];
  }

  @Watch('selectedHardwareId')
  async redrawSchema() {
    this.$forceUpdate();
    await this.setValues();
    await this.drawScheme();
    await this.getPortData();
  }

  // при переходе от списка к svg грузим заново схему
  @Watch('xsOnly')
  async onResized(value: any) {
    if (value) return;

    try {
      this.loading = true;
      this.error = false;
      await this.drawScheme();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  @Watch('editFlag')
  watchEditFlag(flag: boolean) {
    if (!flag) {
      this.key++;
      this.savedCoordinates = [];
    }
  }

  async mounted() {
    try {
      this.loading = true;
      this.error = false;
      await pmoduleModule.fetchAll();
      this.hardwareModuleScheme = await hardwareModule.getModuleScheme();
      await this.drawScheme();
      await this.getPortData();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // Рисуем схему узла
  async drawScheme() {
    this.moduleSchema;
    if (this.moduleSchema) {
      const data = await hardwareModule.getScheme(this.moduleSchema.id);
      if (data) {
        const doc = parseXmlToSvg(data);
        const container = this.$el.querySelector('#scheme');
        const svgElement = this.removeSvgSizeAttributes(doc.documentElement);
        if (container?.children.length) {
          for (let x = 0; x < container?.children.length; x++) {
            container?.children[x].remove();
          }
        }
        container?.appendChild(svgElement);
      }
    }
  }

  // сохраненные первоначальные координаты узлов
  savedCoordinates: {
    id?: number | string;
    coords?: {x: number; y: number} | null;
    name?: string;
  }[] = [];

  /*
    Удаляет с svg атрибуты width и height
    svg без атрибутов width и height, но с указанным атрибутом viewBox подстраивается под размеры внешней svg
  */
  removeSvgSizeAttributes(svgElement: HTMLElement) {
    svgElement.removeAttribute('width');
    svgElement.removeAttribute('height');
    return svgElement;
  }
}
